import { useState, useEffect } from 'react';
import { fetchStudioOverallOverviewPageData } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import { getOptions, getOptionsWithSeparatedGroupKey } from '@gp/utils/common';
import { getOptionsByStringValues } from '@gp/pages/StudioDashboard/StudioOverall/utils';
import { getYearSelectOptions } from '../utils/common';
import {
  MANAGEMENT_SEGMENT_KEY_ISSUES,
  MANAGEMENT_SEGMENT_BOARD_GOVERNANCE,
} from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Management/constants';

import type { IStudioOverallManagementOptionsData } from '../components/Filter';

type IStudioOverallManagementPage = 'key_issue' | 'board_governance';

const STUDIO_OVERALL_MANAGEMENT_PAGES: Record<string, IStudioOverallManagementPage> = {
  [MANAGEMENT_SEGMENT_KEY_ISSUES]: 'key_issue',
  [MANAGEMENT_SEGMENT_BOARD_GOVERNANCE]: 'board_governance',
};

export default function useFilterOptions(segmentId: string) {
  const [isOptionsDataLoading, setIsOptionsDataLoading] = useState(true);
  const [optionsData, setOptionsData] = useState<IStudioOverallManagementOptionsData>({
    studios: [],
    businesses: [],
    dates: [],
  });

  const updateOptionsData = async (segmentId: string) => {
    const page = STUDIO_OVERALL_MANAGEMENT_PAGES[segmentId];
    if (!page) return;
    try {
      setIsOptionsDataLoading(true);
      const res = await fetchStudioOverallOverviewPageData({ page });
      const studios = getOptionsWithSeparatedGroupKey(
        getOptions(res?.studio, {
          textFieldName: 'name',
          valueFieldName: 'id',
        }),
      );
      const businesses = getOptionsWithSeparatedGroupKey(getOptionsByStringValues(res?.business_owner));
      const dates = getYearSelectOptions(res?.meeting_year_list);
      setOptionsData({
        studios,
        businesses,
        dates,
      });
    } catch (exception) {
      console.warn(exception);
      setOptionsData({
        studios: [],
        businesses: [],
        dates: [],
      });
    } finally {
      setIsOptionsDataLoading(false);
    }
  };

  useEffect(() => {
    updateOptionsData(segmentId);
  }, [segmentId]);

  return { isOptionsDataLoading, optionsData };
}
